import React from 'react';
import GraySlowLoader from '@/assets/animation/loading_gray_slow.gif';
import GrayLoader from '@/assets/animation/loading_gray.gif';
import OrangeLoader from '@/assets/animation/loading_orange.gif';
import OrangeSmallLoader from '@/assets/animation/loading_orange_small.gif';
import OrangeMiddleLoader from '@/assets/animation/loading_orange_middle.gif';
import BankOrangeLoader from '@/assets/animation/loading_bank_orange.gif';
import BankOrangeSmallLoader from '@/assets/animation/loading_bank_orange_small.gif';
import BankOrangeMiddleLoader from '@/assets/animation/loading_bank_orange_middle.gif';
import LoadingCircle from '@/assets/img/loading_circle.svg';
import './style.scss';
import { isBank } from '@/config/core';

function Loader(styleName = '', loaderData = GrayLoader) {
  return (
    <div className={styleName}>
      <img src={loaderData} />
    </div>
  );
}

function ListLoader() {
  return Loader('sp-list-loader', isBank() ? BankOrangeLoader : OrangeLoader);
}

function DescLoader() {
  return Loader('sp-desc-loader');
}

function DialogueLoader() {
  return Loader('sp-dialogue-loader-orange', isBank() ? BankOrangeLoader : OrangeLoader);
}

function AgentLoadingLoader() {
  return Loader('sp-agent-loading-loader', isBank() ? BankOrangeSmallLoader : OrangeSmallLoader);
}

function AgentDialogueLoader() {
  return Loader('sp-agent-dialogue-loader', isBank() ? BankOrangeMiddleLoader : OrangeMiddleLoader);
}

function AgentUploadLoading() {
  return Loader('sp-agent-upload-loader', LoadingCircle);
}

export { Loader, ListLoader, DescLoader, DialogueLoader, AgentLoadingLoader, AgentDialogueLoader, AgentUploadLoading };
